var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"py-1",attrs:{"dense":""}},[_c('v-list-item',{attrs:{"dense":"","three-line":""}},[_c('v-list-item-content',{staticClass:"pa-0"},[_c('v-list-item-title',{staticClass:"caption"},[_vm._v(_vm._s(_vm.nombreCampo))]),_c('v-list-item-subtitle',{staticClass:"caption"},[_vm._v(_vm._s(_vm.valorCampo))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }